export default {

    Notes: 'CR/DR Note|CR/DR Notes',
};
